import { atom } from 'nanostores';

export class FormsStore {
  $isDemoOpened = atom(false);

  $isViewFormModalOpen = atom(false);

  $isQuestionOpened = atom(false);

  $isOrderOpened = atom(false);

  store;

  constructor(store) {
    this.store = store;
  }

  openOrderForm() {
    this.$isOrderOpened.set(true);
    this.store.scrollStore.lock('order');
  }

  closeOrderForm() {
    this.$isOrderOpened.set(false);
    this.store.scrollStore.unlock('order');
  }
}
